import { Action } from "redux";
import { ActionsObservable, StateObservable } from "redux-observable";
import { RootState } from ".";
import { Observable, of } from "rxjs";
import { switchMap, map, catchError, filter, withLatestFrom } from "rxjs/operators";
import { ajax, AjaxResponse } from "rxjs/ajax";
import { SUBMIT_LOGIN_FULFILLED, SUBMIT_LOGIN, LoginAction, TOGGLE_CHECKOUT, LOGOUT } from "./login";
import { Node, LOAD_PROFILE_FULFILLED, LoadProfileFulfilledAction, ToggleProfileAction, SELECT_PROFILE } from "./profile";
import { Filter } from "../sections/Sidebar";
import { TokenCheck } from "../helper";

export const LOAD_PHOTOS = "PHOTO_LOAD_PHOTOS";
export const LOAD_COMMS_PHOTOS = "PHOTO_LOAD_COMM_PHOTOS";
export const TOGGLE_SELECT_PHOTO = "PHOTO_TOGGLE_SELECT_PHOTO";
export const LOAD_PHOTO_FULFILLED = "PHOTO_LOAD_PHOTO_FULFILLED";
export const LOAD_PARENT_FULFILLED = "PHOTO_LOAD_PARENT_FULFILLED";
export const LOAD_COMM_PHOTO_FULFILLED = "PHOTO_LOAD_COMM_PHOTO_FULFILLED";
export const LOAD_COMMS_PHOTO_FULFILLED = "PHOTO_LOAD_COMMS_PHOTO_FULFILLED";
export const LOAD_ALBUMS_FULFILLED = "PHOTO_LOAD_ALBUMS_FULFILLED";
export const CLEAR_PHOTOS = "PHOTO_CLEAR_PHOTO";
export const LOAD_PHOTO_FAILED = "PHOTO_LOAD_PHOTO_FAILED";

export const CLOSE_PHOTO = "PHOTO_CLOSE_PHOTO";
export const OPEN_PHOTO = "PHOTO_OPEN_PHOTO";
export const NEXT_PHOTO = "PHOTO_NEXT_PHOTO";
export interface Photo extends Brick {
    type: "photo",
    id: string,
    preview_type: string[],
    [field_name: string]: string | string[] | number
}

export interface Group extends Brick {
    type: "group",
    field: string,
    value: string
}

export interface Brick<T = any> {
    type: T
}

export interface Filters {
    type: string,
    value: string,
}

export interface AlbumNodes {
    nodes: string[]
}


export interface PhotoState {
    bricks: (Photo | Group)[],
    filters: Filter[],
    loaded: boolean,
    selected: Set<string>,
    opened?: string,
    community: boolean,
    communitybricks: (Photo | Group)[]
    albumNodes: string[]
}

const initialState: PhotoState = {
    bricks: [],
    filters: [],
    loaded: false,
    selected: new Set(),
    community: false,
    communitybricks: [],
    albumNodes: []
};



export const getInitialState = (): PhotoState => {
    let config = { ...initialState };

    if (localStorage && localStorage.getItem("S") != undefined) {
        var retrievedObject = localStorage.getItem("S") as string;
        var toArray = JSON.parse(retrievedObject);
        var set = new Set((toArray) as string)
        config.selected = set
    }

    return config;
}

export interface LoadPhotoFulfilled extends Action {
    type: "PHOTO_LOAD_PHOTO_FULFILLED",
    photos: Node[]
    parent: boolean
}

export interface LoadAlbumFulfilled extends Action {
    type: "PHOTO_LOAD_ALBUMS_FULFILLED",
    albums: string[]
}

export interface LoadCommFulfilled extends Action {
    type: "PHOTO_LOAD_COMM_PHOTO_FULFILLED",
    photos: Node[]
}

export interface LoadCommsFulfilled extends Action {
    type: "PHOTO_LOAD_COMMS_PHOTO_FULFILLED",
    photos: Node[]
}

export interface LoadParentFulfilled extends Action {
    type: "PHOTO_LOAD_PARENT_FULFILLED",
    photos: Node[]
}

export interface ClearPhoto extends Action {
    type: "PHOTO_CLEAR_PHOTO",
}

export interface ToggleSelection extends Action {
    type: "PHOTO_TOGGLE_SELECT_PHOTO",
    id: string
}

export interface OpenPhoto extends Action {
    type: "PHOTO_OPEN_PHOTO",
    id: string
}

export interface ClosePhoto extends Action {
    type: "PHOTO_CLOSE_PHOTO",
}

export interface NextPhoto extends Action {
    type: "PHOTO_NEXT_PHOTO",
    forward: boolean
}

export interface ToggleCommAction extends Action {
    type: "PHOTO_LOAD_COMM_PHOTOS",
    selected?: number
}


export type PhotoAction = LoadPhotoFulfilled | LoadAlbumFulfilled | LoadCommFulfilled | LoadCommsFulfilled | LoadParentFulfilled | ToggleCommAction | ClearPhoto | LoginAction | LoadProfileFulfilledAction | ToggleProfileAction | ToggleSelection | OpenPhoto | ClosePhoto | NextPhoto;

export const loadPhotosEpic = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
    action$.pipe(
        filter(action => {
            let token = localStorage.getItem("T") as string;
            if (token != undefined && token != null && (action.type == LOAD_COMMS_PHOTOS || action.type == LOAD_PARENT_FULFILLED || action.type == CLOSE_PHOTO || action.type == NEXT_PHOTO || action.type == OPEN_PHOTO || action.type == LOAD_PROFILE_FULFILLED || action.type == SELECT_PROFILE || action.type == "PROFILE_LOAD_PROFILE_FAILED" || action.type == 'LOGIN_ACCEPT_DISCLAIMER' || action.type == "PROFILE_SELECT_PROFILE")) {
                TokenCheck();
            }
            if (action.type == LOAD_PROFILE_FULFILLED || action.type == SELECT_PROFILE) {
                return true;
            }
            return false;
        }),
        switchMap(action => {

            let url = ""

            let filters = state$.value.photo.filters

            url = "api/v1/query/photo"
            if (state$.value.profile.selected != undefined) {
                let profile = state$.value.profile.profiles[state$.value.profile.selected];
                url += `?fq=sb_relatedID:"${profile.id}"`;

                filters.forEach(filter => {
                    switch (filter.type) {
                        case "year":
                            url += `%20AND%20sb_year:"${filter.value}"`
                            return {
                                url
                            }

                        case "event":
                            url += `%20AND%20sb_event:"${filter.value}"`
                            return {
                                url
                            }
                    }
                })
            } else if (filters.length > 0) {
                url += `?fq=""`;
                filters.forEach(filter => {
                    switch (filter.type) {
                        case "year":
                            url += `%20AND%20sb_year:"${filter.value}"`
                            return {
                                url
                            }

                        case "event":
                            url += `%20AND%20sb_event:"${filter.value}"`
                            return {
                                url
                            }
                    }
                })

                if (state$.value.photo.albumNodes.length != 0) {
                    url += `%20AND%20sb_id:NOT(` + state$.value.photo.albumNodes.join('AND ') + `)`
                }
            }




            let tick = state$.value.login.ticket as string
            let header = { 'Content-Type': 'application/json', "Semabench-Token": tick, "Cache-Control": "max-age=0" };

            return ajax.get(url, {
                "SBPPortal-Ticket": state$.value.login.ticket,
                "user": state$.value.login.username,
                "email": state$.value.login.email
            }).pipe(
                map((response: AjaxResponse) => {
                    let parent = false;
                    if (state$.value.login.enable_quick_parent.toUpperCase() == "TRUE") {
                        parent = true
                    }

                    return {
                        type: LOAD_PHOTO_FULFILLED,
                        photos: response.response,
                        community: [],
                        parent
                    }

                }),
                catchError((error) => of({ type: LOAD_PHOTO_FAILED })))

        }))

export const loadCommEpic = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
    action$.pipe(
        filter(action => {
            if (action.type == LOAD_COMMS_PHOTOS) {
                return true;
            }
            return false;
        }),
        switchMap(action => {

            let filters = state$.value.photo.filters

            let url = "api/v1/query/community"
            if (filters.length > 0) {
                url += `?fq=""`;
                filters.forEach(filter => {
                    switch (filter.type) {
                        case "year":
                            url += `%20AND%20sb_year:"${filter.value}"`
                            return {
                                url
                            }

                        case "event":
                            url += `%20AND%20sb_event:"${filter.value}"`
                            return {
                                url
                            }
                    }
                })
            }


            return ajax.get(url, {
                "SBPPortal-Ticket": state$.value.login.ticket,
                "user": state$.value.login.username,
                "email": state$.value.login.email
            }).pipe(
                map((response: AjaxResponse) => {
                    return {
                        type: LOAD_COMM_PHOTO_FULFILLED,
                        photos: response.response,
                    }

                }),
                catchError((error) => of({ type: LOAD_PHOTO_FAILED })))

        }))

export const loadCommsEpic = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
    action$.pipe(
        filter(action => {
            if (action.type == LOAD_PROFILE_FULFILLED || action.type == SELECT_PROFILE) {
                return true;
            }
            return false;
        }),
        switchMap(action => {

            let url = "api/v1/query/community"


            return ajax.get(url, {
                "SBPPortal-Ticket": state$.value.login.ticket,
                "user": state$.value.login.username,
                "email": state$.value.login.email
            }).pipe(
                map((response: AjaxResponse) => {
                    return {
                        type: LOAD_COMMS_PHOTO_FULFILLED,
                        photos: response.response,
                    }

                }),
                catchError((error) => of({ type: LOAD_PHOTO_FAILED })))

        }))

// export const loadAlbumEpic = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
//     action$.pipe(
//         filter(action => {
//             if (action.type == LOAD_PROFILE_FULFILLED || action.type == SELECT_PROFILE || action.type == SUBMIT_LOGIN) {
//                 return true;
//             }
//             return false;
//         }),
//         switchMap(action => {
//             console.log("DOES THIS GET CALLED????")
//             let url = "api/v1/albums"


//             return ajax.get(url, {
//                 "SBPPortal-Ticket": state$.value.login.ticket,
//                 "user": state$.value.login.username,
//                 "email": state$.value.login.email
//             }).pipe(
//                 map((response: AjaxResponse) => {
//                     return {
//                         type: LOAD_ALBUMS_FULFILLED,
//                         albums: response.response,
//                     }

//                 }),
//                 catchError((error) => of({ type: LOAD_PHOTO_FAILED })))

//         }))

export const loadParentEpic = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
    action$.pipe(
        filter(action => {
            if (action.type == LOAD_PHOTO_FULFILLED && state$.value.login.enable_quick_parent.toUpperCase() != "FALSE") {
                return true;
            }
            return false;
        }),
        switchMap(action => {

            let filters = state$.value.photo.filters

            let url = "api/v1/query/parent"
            if (state$.value.profile.selected != undefined) {
                let profile = state$.value.profile.profiles[state$.value.profile.selected];
                url += `?fq=sb_relatedID:"${profile.id}"`;

                filters.forEach(filter => {
                    switch (filter.type) {
                        case "year":
                            url += `%20AND%20sb_year:"${filter.value}"`
                            return {
                                url
                            }

                        case "event":
                            url += `%20AND%20sb_event:"${filter.value}"`
                            return {
                                url
                            }
                    }
                })
            } else if (filters.length > 0) {
                url += `?fq=""`;
                filters.forEach(filter => {
                    switch (filter.type) {
                        case "year":
                            url += `%20AND%20sb_year:"${filter.value}"`
                            return {
                                url
                            }

                        case "event":
                            url += `%20AND%20sb_event:"${filter.value}"`
                            return {
                                url
                            }
                    }
                })
            }


            return ajax.get(url, {
                "SBPPortal-Ticket": state$.value.login.ticket,
                "user": state$.value.login.username,
                "email": state$.value.login.email
            }).pipe(
                map((response: AjaxResponse) => {
                    return {
                        type: LOAD_PARENT_FULFILLED,
                        photos: response.response
                    }

                }),
                catchError((error) => of({ type: LOAD_PHOTO_FAILED })))

        }))

export default function reducer(state = getInitialState(), action: PhotoAction): PhotoState {
    switch (action.type) {

        case LOGOUT:
            localStorage.removeItem("S");
            return initialState;

        case LOAD_ALBUMS_FULFILLED:
            return {
                ...state,
                albumNodes: []
            }

        case LOAD_PROFILE_FULFILLED:
        case SELECT_PROFILE:
        case SUBMIT_LOGIN:
            return {
                ...state,
                loaded: false
            }
        case LOAD_COMMS_PHOTOS:
            return {
                ...state,
                loaded: false
            }

        case CLEAR_PHOTOS:
            state.selected = new Set();
            if (localStorage) {
                let t = Array.from(state.selected.values());
                localStorage.setItem("S", JSON.stringify(t));
            }

            return {
                ...state,
                selected: new Set()
            }

        case LOAD_PHOTO_FULFILLED:

            let bricks: (Photo | Group)[] = [];

            let cur_year: string | undefined = undefined;

            let has_unknown = false;

            action.photos.forEach((node: Node) => {

                if (cur_year == undefined || node["sb_year"] != cur_year) {

                    let value = node["sb_year"] as string || "Unknown";

                    if (value != "Unknown" || has_unknown == false) {
                        bricks.push({
                            type: "group",
                            field: "sb_year",
                            value
                        });
                    }

                    if (has_unknown == false && value == "Unknown") {
                        has_unknown = true;
                    }

                    cur_year = value
                }

                bricks.push({
                    type: "photo",
                    ...node
                });

            });


            return {
                ...state,
                bricks,
                loaded: !action.parent,
                community: false,
            }
        case LOAD_PARENT_FULFILLED:
            let brick = state.bricks;

            let pcur_year: string | undefined = undefined;

            let phas_unknown = false;

            action.photos.forEach((node: Node) => {

                if (pcur_year == undefined || node["sb_year"] != pcur_year) {

                    let value = node["sb_year"] as string || "Unknown";

                    if (value != "Unknown" || has_unknown == false) {
                        brick.push({
                            type: "group",
                            field: "sb_year",
                            value
                        });
                    }

                    if (phas_unknown == false && value == "Unknown") {
                        phas_unknown = true;
                    }

                    pcur_year = value
                }
                if (phas_unknown) {
                    brick.push({
                        type: "group",
                        field: "sb_year",
                        value: "Unknown"
                    });
                    phas_unknown = false;
                }
                brick.push({
                    type: "photo",
                    ...node
                });
            });

            let uniqueGroup: (Photo | Group)[] = [];
            (brick as Group[]).forEach((group: Group) => {
                let found = false;
                for (var i = 0; i < uniqueGroup.length; i++) {
                    if (uniqueGroup[i].value == group.value) {
                        found = true;
                        continue;
                    }
                }
                if (!found && group.type == "group") {
                    // uniqueGroup.push(group);
                    let uniqueGroupLen = uniqueGroup.length;
                    if (uniqueGroupLen == 0) {
                        uniqueGroup = [group];
                    } else {
                        uniqueGroup.push(group);
                    }
                }
            });

            let unknownIndex = -1;
            let unknownArr;
            for (var i = 0; i < uniqueGroup.length; i++) {
                if ((uniqueGroup[i] as Group).value == "Unknown") {
                    unknownIndex = i;
                    unknownArr = uniqueGroup[i];
                    break;
                }
            }

            if (unknownIndex != -1) {
                uniqueGroup.splice(unknownIndex, 1);
            }

            uniqueGroup.sort(function (a, b) {
                return (b.value > a.value) ? 1 : (b.value < a.value) ? -1 : 0;
            });

            if (unknownArr != undefined) {
                uniqueGroup.push(unknownArr as Group);
            }

            let displayArr: (Photo | Group)[] = [];

            uniqueGroup.forEach(year => {

                displayArr.push(year);
                if (brick.length > 0) {
                    (brick as Photo[]).forEach(photo => {
                        if (year != undefined) {
                            if (photo["sb_year"] == year.value) {
                                let found = false;
                                for (var i = 0; i < displayArr.length; i++) {
                                    if (photo.id == (displayArr[i] as Photo).id) {
                                        found = true;
                                        break;
                                    }
                                }
                                if (!found) {
                                    displayArr.push(photo);
                                }
                            }
                        }
                    })
                }
            });

            let unknownAvailable = false;
            try {

                unknownAvailable = uniqueGroup[uniqueGroup.length - 1].value == "Unknown";
            } catch {
                unknownAvailable = false;
            }

            if (unknownAvailable) {
                (brick as Photo[]).forEach(photo => {
                    if (photo["sb_year"] == undefined) {
                        let found = false;
                        for (var i = 0; i < displayArr.length; i++) {
                            if (photo.id == (displayArr[i] as Photo).id) {
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            displayArr.push(photo);
                        }
                    }
                })
            }

            return {
                ...state,
                bricks: displayArr,
                loaded: true
            }
        case LOAD_COMMS_PHOTO_FULFILLED:
            let commbricks = state.communitybricks;

            if (action.photos.length > 0) {
                commbricks = [];

                let ccur_year: string | undefined = undefined;

                let chas_unknown = false;

                action.photos.forEach((node: Node) => {

                    if (ccur_year == undefined || node["sb_year"] != ccur_year) {

                        let value = node["sb_year"] as string || "Unknown";

                        if (value != "Unknown" || chas_unknown == false) {
                            commbricks.push({
                                type: "group",
                                field: "sb_year",
                                value
                            });
                        }

                        if (chas_unknown == false && value == "Unknown") {
                            chas_unknown = true;
                        }

                        ccur_year = value
                    }

                    commbricks.push({
                        type: "photo",
                        ...node
                    });

                });
            }

            return {
                ...state,
                communitybricks: commbricks,
            }

        case LOAD_COMM_PHOTO_FULFILLED:
            let communitybricks = state.communitybricks;

            if (action.photos.length > 0) {
                communitybricks = [];

                let ccur_year: string | undefined = undefined;

                let chas_unknown = false;

                action.photos.forEach((node: Node) => {

                    if (ccur_year == undefined || node["sb_year"] != ccur_year) {

                        let value = node["sb_year"] as string || "Unknown";

                        if (value != "Unknown" || chas_unknown == false) {
                            communitybricks.push({
                                type: "group",
                                field: "sb_year",
                                value
                            });
                        }

                        if (chas_unknown == false && value == "Unknown") {
                            chas_unknown = true;
                        }

                        ccur_year = value
                    }

                    communitybricks.push({
                        type: "photo",
                        ...node
                    });

                });
            }

            return {
                ...state,
                communitybricks,
                loaded: true,
                community: true
            }
        case TOGGLE_CHECKOUT:
            if (action.id != undefined) {
                state.selected.add(action.id);
            }

            return {
                ...state
            }

        case TOGGLE_SELECT_PHOTO:
            if (state.selected.has(action.id)) {
                state.selected.delete(action.id);
            } else {
                state.selected.add(action.id);
            }

            if (localStorage) {
                let t = Array.from(state.selected.values());
                localStorage.setItem("S", JSON.stringify(t));
            }

            return {
                ...state
            }

        case OPEN_PHOTO:
            return {
                ...state,
                opened: action.id
            }

        case CLOSE_PHOTO:
            return {
                ...state,
                opened: undefined
            }

        case NEXT_PHOTO:

            let next_index = 0;

            if (state.opened != undefined) {
                if (state.community) {
                    next_index = state.communitybricks.findIndex((brick) => brick.type == "photo" && brick.id == state.opened);
                } else {
                    next_index = state.bricks.findIndex((brick) => brick.type == "photo" && brick.id == state.opened);
                }


                if (next_index == -1) {
                    next_index = 0;
                }


            }

            do {
                next_index = next_index + (action.forward ? 1 : -1);

                if (next_index > state.bricks.length - 1) {
                    next_index = 0;
                }

                if (next_index < 0) {
                    next_index = state.bricks.length - 1;
                }

            } while (state.bricks[next_index].type == "group")

            let next_photo = state.bricks[next_index] as Photo;


            if (state.community) {
                next_index = 0;

                if (state.opened != undefined) {
                    if (state.community) {
                        next_index = state.communitybricks.findIndex((brick) => brick.type == "photo" && brick.id == state.opened);
                    }


                    if (next_index == -1) {
                        next_index = 0;
                    }


                }

                do {
                    next_index = next_index + (action.forward ? 1 : -1);

                    if (next_index > state.communitybricks.length - 1) {
                        next_index = 0;
                    }

                    if (next_index < 0) {
                        next_index = state.communitybricks.length - 1;
                    }

                } while (state.communitybricks[next_index].type == "group")

                next_photo = state.communitybricks[next_index] as Photo;

            }

            return {
                ...state,
                opened: next_photo.id
            }

        default:
            return state;
    }


}



/*
export function ratio(photo: Photo): number {
    return photo.width / photo.height;
}


export function computeSizes(photos: Photo[], columns: number, width?: number, margin = 0): Photo[] {
    if (!width) {
      return [];
    }
    // divide photos over rows, max cells based on `columns`
    // effectively resulting in [[0, 1, 2], [3, 4, 5], [6, 7]]
    const rows = photos.reduce((acc, cell, idx) => {
      const row = Math.floor(idx / columns);
      acc[row] = acc[row] ? [...acc[row], cell] : [cell]; // eslint-disable-line no-param-reassign
      return acc;
    }, [] as Photo[][]);
    // calculate total ratio of each row, and adjust each cell height and width
    // accordingly.
    let ratios: number[] = [];
    const rowsWithSizes = rows.map((row, rowIndex) => {
      const totalRatio = row.reduce((result, photo) => result + ratio(photo), 0);
      const rowWidth = width - row.length * (margin * 2);

      // save total ratio of each row
      if (rowIndex !== rows.length - 1) ratios.push(totalRatio);

      // assign height
      // 3 scenarios...
      //  if its a regular row where row.length === columns
      //    rowWidth / totalRatio
      //  if columns > row.length
      //    if !lastRow
      //      use the average aspect ratio of previous rows
      //    else (all photos are on a single row)
      //      ...
      const height =
        row.length === columns
          ? rowWidth / totalRatio
          : photos.length < columns
            ? rowWidth / totalRatio * (row.length / columns)
            : rowWidth / (ratios.reduce((acc, item) => acc + item, 0) / (rows.length - 1));

      return row.map(photo => ({
        ...photo,
        height: Math.round(height),
        width: Math.round(height * ratio(photo)),
      }));
    });
    return rowsWithSizes.reduce((acc, row) => [...acc, ...row], []);
}

*/